var React = require('react');

function Signboard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 0C1.44772 0 1 0.447715 1 1V6C1 6.55228 1.44772 7 2 7H10C10.5523 7 11 6.55228 11 6V1C11 0.447715 10.5523 0 10 0H2Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M7 8H5V12H7V8Z","fill":"currentColor","key":1})]);
}

Signboard.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Signboard;

Signboard.default = Signboard;
